var render = function render(){var _vm=this,_c=_vm._self._c;return _c('News',{attrs:{"code":"association_dynamic","leftTitle":"热点内容"}})
}
var staticRenderFns = []

export { render, staticRenderFns }